import idFixer from "utils/idFixer";

const REMINDER_KEYS = ["has_reminder", "reminders"];

export const getReminders = message =>
  Array.isArray(message?.reminders) ? message.reminders : [];

export const hasReminder = message =>
  parseInt(message?.has_reminder) === 1 || getReminders(message).length > 0;

export const getReminderTaskId = reminder => reminder?.task_id || reminder?.id;

export const getReminderDate = reminder => {
  if (!reminder?.trigger_date) {
    return null;
  }

  const date = new Date(reminder.trigger_date);
  return isNaN(date.getTime()) ? null : date;
};

export const sortReminders = reminders =>
  [...reminders].sort((a, b) => {
    const first = getReminderDate(a);
    const second = getReminderDate(b);

    if (!first && !second) return 0;
    if (!first) return 1;
    if (!second) return -1;

    return first - second;
  });

export const applyReminderFields = (target, source) => {
  if (!target || !source) {
    return;
  }

  REMINDER_KEYS.forEach(key => {
    if (key in source) {
      target[key] = source[key];
    }
  });
};

export const getRowReminderSource = (message, noMore) => {
  if (
    noMore &&
    message?.listingType === "conversation" &&
    message?.child_content &&
    idFixer(message.child_content.id) === idFixer(message.id)
  ) {
    return message.child_content;
  }

  return message;
};

const parseMessageRef = value => {
  if (!value) {
    return null;
  }

  const str = String(value);
  const separator = str.indexOf(":");
  const rawId = separator > -1 ? str.substring(0, separator) : str;
  const messageId = parseInt(rawId);

  if (!messageId || isNaN(messageId)) {
    return null;
  }

  return {
    messageId,
    folder: separator > -1 ? str.substring(separator + 1) || null : null
  };
};

export const getTaskMessageRef = task => {
  if (!task) {
    return null;
  }

  const fromDescription =
    typeof task.description === "string"
      ? task.description.match(/data-message="([^"]+)"/)?.[1]
      : null;

  return (
    parseMessageRef(task.messageInfo) ||
    parseMessageRef(task.message_id) ||
    parseMessageRef(fromDescription)
  );
};
